import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import { isEmpty } from 'lodash';

import Projects from '../../../api/Projects/Projects';

import PageHeader from '../../atoms/PageHeader';
import Loading from '../../components/Loading';
import ProjectEditor from '../../components/ProjectEditor';
import NotFound from '../NotFound';

const EditProject = ({ project, history, loading, deployEnv }) => {
  if (loading) return <Loading />;
  if (isEmpty(project)) return <NotFound />;
  return (
    <>
      <PageHeader>
        <h4>{`Editing "${project.name}"`}</h4>
      </PageHeader>
      <ProjectEditor project={project} history={history} deployEnv={deployEnv} />
    </>
  );
};

EditProject.defaultProps = {
  project: {}
};

EditProject.propTypes = {
  project: PropTypes.object,
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  deployEnv: PropTypes.string.isRequired
};

export default withTracker(({ match }) => {
  const projectId = match.params.project_id;
  const subscription = Meteor.subscribe('projects.view', projectId);

  return {
    loading: subscription && !subscription.ready(),
    project: Projects.findOne({ _id: projectId, deleted: { $eq: 'no' } })
  };
})(EditProject);
